<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row mt-3">
                <div class="col-md-12">
                    <div class="form-group">
                        <label style="font-size: 20px;">Email Template</label>
                        <select class="form-control mt-2"  name="cars" id="cars" v-model="template" @change="changeTemplate">
                            <template v-for="email_template in mailtemplates" >
                                <optgroup :label="email_template.label" v-bind:key="email_template.slug">
                                    <template v-for="template_data in email_template.data">
                                        <option :value="template_data.template_id" v-bind:key="template_data.template_id">{{ template_data.template_name }}</option>
                                    </template>
                                </optgroup>

                            </template>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12" style="display: flex;justify-content: space-between;">
                    <button class="button" type="button" v-on:click="sendTemplateEmail(false)"> Send Email </button>
                    <button class="button" type="button" v-on:click="showBookingChangeOptions = true" v-if="notifyCustomer"> Notify Customer and Send Email </button>
                </div>
            </div>
            <div class="row mt-2" v-if="showBookingChangeOptions">
                <div class="col-md-12 mt-3">
                    <ChangeReasonModal 
                        buttonText="Send Email"
                        :bookingChangeReasons="bookingChangeReasons"
                        @triggerEmail="triggerEmail"/>
                </div>
            </div>
            <div class="row mt-5" v-if="selectedTemplate">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <h5> Subject:- {{ selectedTemplate.template_subject }} </h5>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-12" v-html="selectedTemplate.template_body_content">
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <div class="row mt-2" v-if="AttachedDocsWithEmail">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <h5> Documents sent with this email : </h5>
                            <p style="
                                font-size: 15px;
                                font-weight: 500;
                                color: orange;
                            ">
                                {{ AttachedDocsWithEmail }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import ChangeReasonModal from "@/components/BookingEdit/ChangeReasonModal.vue"
import { type } from "os";
export default {
    name:'EmailCustomerModal',
    props:{
        mailtemplates:Array,
        bookingChangeReasons: Array,
        selectedDocuments: Array,
        notifyCustomer: {
            type: Boolean,
            default: true
        }
    },
    components: {
        ChangeReasonModal
    },
    computed:{
        AttachedDocsWithEmail() {
            // Add documents from selectedDocuments
            const attachedDocs = (this.selectedDocuments.length > 0 ) ? this.selectedDocuments.map((doc) => doc.label) : [];
            const additionalDocs = (this.selectedTemplate && (this.selectedTemplate.selected_doc_types && this.selectedTemplate.selected_doc_types.length > 0 )) ? this.selectedTemplate.selected_doc_types.map((doc) => doc.label) : [];
            
            // Merge both arrays and remove duplicates
            const uniqueDocs = [...new Set([...attachedDocs, ...additionalDocs])]; 
            return uniqueDocs.length > 0 ? uniqueDocs.join(', ') : '';
        }
    },
    data(){
        return {
            template : null,
            selectedTemplate: null,
            showBookingChangeOptions:false,
        }
    },
    methods :{
        sendTemplateEmail(intimate_customer){
            if (!this.template) {
                this.$notify({
                    type: 'warning',
                    title: 'Plase select a template'
                });
                return;
            }

            this.$emit('sendEmailToCustomer',this.template,intimate_customer)
        },
        changeTemplate(){
            let selectedTemplateID = this.template
            let foundtemp = null
            this.mailtemplates.forEach((element) => {
                let elementObject = Object.values(element.data)
                // let templates = (array)element.data
                let foundElement = elementObject.find(function(el) {
                    return el.template_id == selectedTemplateID
                })
                if (foundElement) {
                    foundtemp = foundElement
                }
            })

            this.selectedTemplate = foundtemp
        },
        triggerEmail(selectedReasons) {
            this.$emit('sendEmailToCustomer',this.template,true,selectedReasons)
        }
    }
}
</script>